import { InitialTargetShareOption } from 'further-types/allocations';

export const InitialTargetShareOptionLabels = {
  [InitialTargetShareOption.InitialTargetShares]: 'Initial target shares',
  [InitialTargetShareOption.InitialTargetInvestment]:
    'Initial target investment',
  [InitialTargetShareOption.InitialTargetAllocationPercent]:
    'Initial target allocation %',
  [InitialTargetShareOption.InitialTargetInvestmentAndShares]:
    'Target investment and shares',
};
